import React from "react";
import { Button, Col, Row } from "components/bootstrap";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import ForwarderSelectionList from "./ForwarderSelectionList";
import { StyledSection, StyledTitle } from "../StyledWizardComponents";
const SelectForwarder = ({ forwarders = void 0, onForwarderSelect, onStartForwarderClick }) => {
  const sendTelemetry = useSendTelemetry();
  const handleForwarderSelection = () => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.FORWARDER.FORWARDER_WIZARD_CONFIGURE_FORWARDER_SELECTED, {
      app_pathname: "forwarder",
      app_section: "forwarder-create"
    });
    onForwarderSelect();
  };
  return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 6 }, /* @__PURE__ */ React.createElement(StyledTitle, null, "Select Forwarder"), /* @__PURE__ */ React.createElement(StyledSection, null, /* @__PURE__ */ React.createElement("p", null, "Haven't started a Forwarder yet? Click here for instructions."), /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", onClick: onStartForwarderClick }, "Start new Forwarder")), /* @__PURE__ */ React.createElement(StyledSection, null, /* @__PURE__ */ React.createElement("p", null, "Or select one of the recently registered Forwarders from the list:"), /* @__PURE__ */ React.createElement(ForwarderSelectionList, { forwarders, onForwarderSelect: handleForwarderSelection }))));
};
export default SelectForwarder;
